export function cf7Mutltistep() {
  document.addEventListener("DOMContentLoaded", function () {
    const steps = document.querySelectorAll(".cf7-step");
    const progressBar = document.getElementById("cf7-progress-bar");
    const stepLabel = document.getElementById("cf7-step-label");
    const form = document.querySelector(".simple-form");
    const header = document.querySelector("header");
    let currentStep = 0;

    if (progressBar) {
      function showStep(index) {
        steps.forEach((step, i) => {
          step.classList.toggle("active", i === index);
          step.classList.toggle("hidden", i !== index);
        });

        // Updated for 2 steps (Step 1 = 50%, Step 2 = 100%)
        const progressMap = [50, 100];

        progressBar.style.width = progressMap[index] + "%";

        if (stepLabel) {
          stepLabel.textContent = `Step ${index + 1} of ${steps.length}`;
          stepLabel.classList.toggle("hidden", index === 1 && document.querySelector(".cf7-step-head"));
        }

        // Update step circles
        document.querySelectorAll(".cf7-step-circle").forEach((dot, i) => {
          dot.classList.remove("bg-secondary", "ring-secondary");
          dot.classList.add("bg-gray-300");
          if (i <= index) {
            dot.classList.remove("bg-gray-300");
            dot.classList.add("bg-secondary");
          }
          if (i === index) {
            dot.classList.add("ring-secondary");
          }
        });

        const calendly = document.getElementById("cf7-calendly");
        const fields = document.getElementById("cf7-form-fields");
        const minSpend = document.getElementById("cf7-min-spend");
        if (index === 1 && calendly && fields && minSpend) {
          const campaignField = document.querySelector('[name="campaigns-per-month"], [name="campaigns-per-month[]"], #campaigns-per-month');
          const spendField = document.querySelector('[name="ad-spend"], [name="ad-spend[]"], #ad-spend');
          const campaignValue = campaignField?.value || "";
          const spendValue = spendField?.value || "";
          const campaigns = parseInt(campaignValue, 10) || 0;
          const spend = /under/i.test(spendValue)
            ? 0
            : parseInt(String(spendValue).replace(/[£,]/g, ""), 10) || 0;
          minSpend.classList.toggle("hidden", spend >= 1000);
          calendly.classList.toggle("hidden", spend < 1000 || campaigns <= 4);
          fields.classList.toggle("hidden", spend < 1000 || campaigns > 4);
        }
      }

function validateStep(index) {
  const currentStepEl = steps[index];
  const fields = currentStepEl.querySelectorAll("input, textarea, select");
  let stepIsValid = true;

  fields.forEach((field) => {
    // We only care about visible, required fields
    if (field.hasAttribute("required") && field.offsetParent !== null) {
      if (!field.value.trim()) {
        stepIsValid = false;
        // Simple visual hint
        field.style.border = "2px solid red";
      } else {
        field.style.border = ""; 
      }
    }
  });

  return stepIsValid;
}

      document.addEventListener("click", function (e) {
        if (e.target.classList.contains("next")) {
  e.preventDefault();
  // Only proceed if the manual check passes
  if (validateStep(currentStep)) {
    if (currentStep < steps.length - 1) {
      currentStep++;
      showStep(currentStep);
    }
    // Scroll to top of form
    window.scroll({
      top: form.offsetTop - header.offsetHeight,
      left: 0,
      behavior: "smooth",
    });
  }
}

        if (e.target.classList.contains("prev")) {
          e.preventDefault();
          if (currentStep > 0) {
            currentStep--;
            showStep(currentStep);
          }
          window.scroll({
            top: form.offsetTop - header.offsetHeight,
            left: 0,
            behavior: "smooth",
          });
        }
      });

      // Init
      showStep(currentStep);

      const campaignField = document.querySelector('[name="campaigns-per-month"], [name="campaigns-per-month[]"], #campaigns-per-month');
      const spendField = document.querySelector('[name="ad-spend"], [name="ad-spend[]"], #ad-spend');
      const nextButton = document.querySelector(".cf7-step.step-1 .next");

      if (campaignField && spendField && nextButton) {
        function hasValue(field) {
          const value = (field.value || "").trim();
          return value !== "" && value.toLowerCase() !== "please select";
        }

        function updateNextButton() {
          nextButton.disabled = !(hasValue(campaignField) && hasValue(spendField));
        }

        campaignField.addEventListener("change", updateNextButton);
        spendField.addEventListener("change", updateNextButton);
        updateNextButton();
      }
    }
  });
}
